import { MAX_TRIAL_NOVEL_IMPORTS } from "../../../../src/shared/constants";

export const TRIAL_IMPORT_LIMIT_TOOLTIP = "Subscribe to import more than two projects.";

export function hasReachedTrialImportLimit(subscription, userMetadata, isImportDisabled = false) {
  const activeTrial = typeof subscription?.activeTrial === "function" ? subscription.activeTrial() : subscription?.activeTrial;
  const novelImports = userMetadata?.novelImports ?? 0;

  return !!activeTrial && (isImportDisabled || novelImports >= MAX_TRIAL_NOVEL_IMPORTS);
}
